<template>
  <el-card>
    <template #header>
      <content-header>
        广告管理
      </content-header>
    </template>

    <div class="header-button">
      <search-form ref="searchForm" :fields="search"/>
      <div class="selections">
        <button-link type="success" :to="link">
          <slot>添加子广告</slot>
        </button-link>
      </div>
    </div>

    <el-table :data="advertisements" resource="advertisement-children">
     <!-- <el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->
      <el-table-column
        prop="advertisement_position_id"
        label="广告位"
        align="center"
        show-overflow-tooltip
        min-width="4%"
      >
        <template slot-scope="scope">
          <div v-for="(item,index) in advertisement_position" :key="index">
            <el-tag v-if="item.slug == scope.row.advertisement_position_slug">{{ item.name }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="广告名称"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <el-table-column
        prop="type"
        label="广告类型"
        align="center"
        show-overflow-tooltip
        min-width="4%"
      >
        <template slot-scope="scope">
          <div v-for="(item,index) in advertisement_type" :key="index">
            <el-tag v-if="item.slug == scope.row.type">{{ item.name }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="层级"
        align="center"
        show-overflow-tooltip
        min-width="3%"
      />
      <el-table-column
        label="广告缩略图"
        align="center"
        show-overflow-tooltip
        min-width="11%"
      >
        <template slot-scope="scope">
          <img :src="scope.row.surface" min-width="60" height="60">
        </template>
      </el-table-column>
      <el-table-column
        prop="area_name"
        label="投放区域"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />

      <el-table-column
        label="是否展示"
        align="center"
        show-overflow-tooltip
        min-width="3%"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_display == 1" type="success">已展示</el-tag>
          <el-tag v-else type="danger">未展示</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        align="center"
        show-overflow-tooltip
        min-width="6%"
      />
      <el-table-column
        prop="end_time"
        label="结束时间"
        align="center"
        show-overflow-tooltip
        min-width="6%"
      />
      <!-- <el-table-column label="服务时间" width="200">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.customer_service_time }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="customer_service_phone" label="服务手机号"/> -->

      <el-table-column label="操作" width="280">
        <template #default="{  }">
          <row-to-edit/>
          <row-destroy/>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page"/>
    </div>
  </el-card>
</template>
<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getAdvertisement, getAdvertisementSelectData } from '@/api/advertisement'
import { getAreas } from '@/api/area'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'
import ButtonLink from '@c/ButtonLink'
import { mixinsAutoPageSize } from '@/libs/utils'

// import RowAddParking from './components/RowAddParking'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink,
  },
  data() {
    return {
      search: [
        {
          type: 'el-select',
          field: 'area_id',
          label: '投放区域',
          options: [
            {
              id: '',
              name: '全部',
            },
          ],
        },
        {
          type: 'el-select',
          field: 'advertisement_position_slug',
          label: '广告位',
          options: [
            {
              value: '',
              name: '全部',
            },
          ],
        },
        {
          type: 'el-select',
          field: 'type',
          label: '广告类型',
          options: [
            {
              value: '',
              name: '全部',
            },
          ],
        },
        {
          field: 'id',
          label: 'ID',
        },
        {
          field: 'name',
          label: '名称',
        },
      ],
      advertisements: [],
      page: null,
      advertisement_position: [],
      advertisement_type: [],
      first_blood: true,
      pid: 0,
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal)
        this.pid = this.$route.params.pid || 0

        console.log(this.pid)
        if (this.pid !== 0) {
          newVal.query.pid = this.pid
        }
        const { data: { data, meta } } = await getAdvertisement(newVal.query)
        this.advertisements = data
        this.page = meta
      },
      immediate: true,
    },
  },
  methods: {
    addAdvertisement() {
      console.log(111)
    },
  },
  computed: {
    link() {
      // this.checkResourceName()
      // console.log(this.identify)
      return `/advertisement-children/create/` + this.pid
    },
  },
  async created() {
    const [
      { data: selectData },
    ] = await Promise.all([
      getAdvertisementSelectData(),
    ])
    this.advertisement_position = selectData.advertisementPosition
    this.advertisement_type = selectData.advertisementType
    // eslint-disable-next-line camelcase
    let type_data = []
    this.advertisement_type.map(i => {
      type_data.push({ value: i.slug, label: i.name })
    })
    let position_data = []
    this.advertisement_position.map(i => {
      position_data.push({ value: i.slug, label: i.name })
    })
    // console.log(position_data)
    this.search[1].options.push.apply(this.search[1].options, position_data)
    this.search[2].options.push.apply(this.search[2].options, type_data)
    const [
      { data: areas },
    ] = await Promise.all([
      getAreas({ all: 1 }),
    ])
    this.search[0].options.push.apply(this.search[0].options, areas)
    // console.log(this.advertisement_position)
  },
}
</script>

<style lang="scss">
.header-button{
  display:flex;
  justify-content: space-between;
  .selections{
      display: inline-block;
      margin-right:10px
    }
}
</style>
